// Game Status
export const GAME_STATUS = {
  INITIATED: 'initiated',
  PLAYING: 'playing',
  PENDING_STOP: 'pending_stop', // status after clicking stop button
  STOPPED: 'stopped',
  ENDED: 'ended',
} as const;
type GameStatusKeys = keyof typeof GAME_STATUS;
export type GameStatus = (typeof GAME_STATUS)[GameStatusKeys];

// Game Action
export const GAME_ACTION = {
  START: 'start', // click will start the stopped game
  RESUME: 'resume', // click will start the paused game
  PAUSE: 'pause',
  STOP: 'stop',
  STOP_REVERT: 'stop_revert',
} as const;
type GameActionKeys = keyof typeof GAME_ACTION;
export type GameAction = (typeof GAME_ACTION)[GameActionKeys];

// play status action, also includes player status
export const PLAYER_STATUS_ACTION = {
  AWAY: 'away',
  LEFT: 'left',
  AWAY_BACK: 'back',
  READY: 'ready', // sit back after left
  LEFT_BY_ADMIN: 'left_by_admin',
} as const;
type PlayerStatusActionKeys = keyof typeof PLAYER_STATUS_ACTION;
export type PlayerStatusAction =
  (typeof PLAYER_STATUS_ACTION)[PlayerStatusActionKeys];

// game stage
export const GAME_STAGE = {
  PREFLOP: 'preflop',
  FLOP: 'flop',
  TURN: 'turn',
  RIVER: 'river',
  SETTLE: 'settle', // calculate everyone's balance before ended
  ENDED: 'ended',
} as const;
type GameStageKeys = keyof typeof GAME_STAGE;
export type GameStage = (typeof GAME_STAGE)[GameStageKeys];

// player actions
export const PLAYER_ACTION = {
  CALL: 'call',
  RAISE: 'raise',
  CHECK: 'check',
  FOLD: 'fold',
  ALL_IN: 'all_in',
  SHOW_CARDS: 'show_cards',
  CHECK_OR_FOLD: 'check_or_fold',
  RABBIT_HUNGTING: 'rabbit_hunting',
} as const;
type PlayerActionKeys = keyof typeof PLAYER_ACTION;
export type PlayerAction = (typeof PLAYER_ACTION)[PlayerActionKeys];

// hand name: the reward name of that hand
export const HAND_NAME = {
  STRAIGHT_FLUSH: 'Straight Flush',
  ROYAL_FLUSH: 'Royal Flush',
  WILD_ROYAL_FLUSH: 'Wild Royal Flush',
  FIVE_OF_A_KIND: 'Five of a Kind',
  FOUR_OF_A_KIND_WITH_PAIR_OR_BETTER: 'Four of a Kind with Pair or Better',
  FOUR_OF_A_KIND: 'Four of a Kind',
  FOUR_WILD_CARDS: 'Four Wild Cards',
  THREE_OF_A_KIND_WITH_TWO_PAIR: 'Three of a Kind with Two Pair',
  FULL_HOUSE: 'Full House',
  FLUSH: 'Flush',
  STRAIGHT: 'Straight',
  THREE_PAIR: 'Three Pair',
  TWO_PAIR: 'Two Pair',
  PAIR: 'Pair',
  HIGH_CARD: 'High Card',
} as const;
type HandNameKeys = keyof typeof HAND_NAME;
export type HandName = (typeof HAND_NAME)[HandNameKeys];

// sort order in the ledger page
export const SORT_ORDER = {
  ASC: 'asc',
  DESC: 'desc',
} as const;
type SortOrderKeys = keyof typeof SORT_ORDER;
export type SortOrder = (typeof SORT_ORDER)[SortOrderKeys];

// game logs
export const HAND_LOG_ACTIONS = {
  CREATE_GAME: 'create_game',
  UPDATE_GAME_CONFIG: 'update_game_config',
  VERIFY_TOPUP: 'verify_topup',
  ADMIN_ACTION: 'admin_action',
  USER_SEAT_ACTION: 'user_seat_action',
  USER_SEAT_ACTION_BY_ADMIN: 'user_seat_action_by_admin',
  USER_BUYOUT: 'user_buyout',
  UTG_STRAGGLE: 'utg_straddle',
} as const;
type HandLogKeys = keyof typeof HAND_LOG_ACTIONS;
export type HandLog = (typeof HAND_LOG_ACTIONS)[HandLogKeys];

// status when user topup or deposit
export const DEPOSIT_STATUS = {
  INIT: 'init',
  PENDING: 'pending',
  SUCCESS: 'success',
  FAILED: 'failed',
} as const;
type DepositStatusKeys = keyof typeof DEPOSIT_STATUS;
export type DepositStatusValues = (typeof DEPOSIT_STATUS)[DepositStatusKeys];

// buy out status from api
export const CASH_OUT_STATUS = {
  INIT: 'initiated',
  ISSUED: 'issued',
  FAILED: 'failed',
  SUCCESS: 'success',
} as const;
type CashOutStatusKeys = keyof typeof CASH_OUT_STATUS;
export type CashOutStatus = (typeof CASH_OUT_STATUS)[CashOutStatusKeys];

// status when user withdraw
export const CASH_OUT_PROCESS_STATUS = {
  INIT: 'INIT',
  PROCESSING: 'PROCESSING',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
} as const;
type CashOutProcessStatusKeys = keyof typeof CASH_OUT_PROCESS_STATUS;
export type CashOutProcessStatus =
  (typeof CASH_OUT_PROCESS_STATUS)[CashOutProcessStatusKeys];

// retry step when user cash out failed
export const CASH_OUT_RETRY_STEP = {
  ON_CASH_OUT: 'onCashOut',
  ON_WITHDRAW_ON_CONTRACT: 'onWithdrawOnContract',
  ON_VERIFY_WITHDRAW: 'onVerifyWithdraw',
} as const;
type CashOutRetryStepKeys = keyof typeof CASH_OUT_RETRY_STEP;
export type CashOutRetryStep =
  (typeof CASH_OUT_RETRY_STEP)[CashOutRetryStepKeys];

export const FEEDBACK_URL = `https://forms.gle/3DLyaek98yxJuJWJ6`;
